module.exports = __webpack_public_path__ + "img/service2-03.e8c1812f.png";